import React, { createContext } from 'react';
import Pusher from 'pusher-js'
import { PusherContextProviderType, PusherContextType } from '../types/PusherType';
declare global{
  var pusher:any
}
export const PusherContext = createContext<PusherContextType | null>( null );
export const PusherContextProvider = ({children}: PusherContextProviderType) => {
    const idUsuario = localStorage.getItem('@DommusCRM-usuario_id')
    const pusherChannel = "central_ajuda_cliente_"+idUsuario;
    if(!(global.pusher)){
        global.pusher = new Pusher('ZWmsypUbT9C', {
            wsHost: 'wsdommus.dommus2.com.br',
            wssPort: 6001,
            forceTLS: true,
            enabledTransports: ['ws', 'wss']
        });
    }
    const pusherState = global.pusher?.subscribe(pusherChannel)
    
    return(
        <PusherContext.Provider value={{pusherState, pusherChannel}}>
            {children}
        </PusherContext.Provider>
    )
}
